var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "columns is-gapless" }, [
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "field has-addons" }, [
            _c(
              "div",
              { staticClass: "control has-icons-left has-icons-right" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter.query,
                      expression: "filter.query",
                    },
                  ],
                  staticClass: "input",
                  attrs: {
                    type: "text",
                    placeholder: "Start typing to filter",
                  },
                  domProps: { value: _vm.filter.query },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.filter, "query", $event.target.value)
                      },
                      _vm.search,
                    ],
                  },
                }),
                _vm._m(0),
              ]
            ),
            _c("div", { staticClass: "control" }, [
              _c(
                "a",
                {
                  staticClass: "button is-primary is-outlined tooltip",
                  attrs: { "data-tooltip": "Reset search" },
                  on: {
                    click: function ($event) {
                      return _vm.reset()
                    },
                  },
                },
                [_vm._m(1)]
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "column is-narrow" }, [
          _c("div", { staticClass: "field is-horizontal is-pulled-right" }, [
            _c("div", { staticClass: "field-body" }, [
              _c("p", { staticClass: "buttons" }, [
                _c(
                  "a",
                  {
                    staticClass: "button tooltip",
                    attrs: {
                      disabled: _vm.isLockPurchaseOrder,
                      "data-tooltip": "Add all items",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.setSelectedAll(true)
                      },
                    },
                  },
                  [_vm._m(2)]
                ),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.selectedItems.length,
                        expression: "selectedItems.length",
                      },
                    ],
                    staticClass: "button tooltip",
                    attrs: {
                      disabled: _vm.isLockPurchaseOrder,
                      "data-tooltip": "Delete all items",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.setSelectedAll(false)
                      },
                    },
                  },
                  [_vm._m(3)]
                ),
              ]),
            ]),
          ]),
          _vm.isLockPurchaseOrder
            ? _c("div", [_c("order-lock-notification")], 1)
            : _vm._e(),
        ]),
      ]),
      _c(
        "bulma-table",
        {
          staticClass: "table is-bordered is-striped is-narrow is-fullwidth",
          attrs: {
            columns: _vm.columns,
            "page-index": _vm.filter.pageIndex,
            "page-size": _vm.filter.pageSize,
            "total-rows": _vm.totalRows,
            "is-loading": _vm.isTableLoading,
            "sort-column": _vm.filter.sortColumn,
            "sort-order": _vm.filter.sortOrder,
            draggable: false,
          },
          on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
        },
        [
          _vm._l(_vm.pagedActiveItems, function (item, index) {
            return _c(
              "tr",
              {
                key: item.quoteItemId,
                class: { "is-selected": _vm.selectedRow === index },
                on: {
                  click: function ($event) {
                    return _vm.highlightSelected(index, $event)
                  },
                  dblclick: function ($event) {
                    return _vm.addNewItem(item, true)
                  },
                },
              },
              [
                _c("td", { staticClass: "itemno-input" }, [
                  _vm._v(_vm._s(item.itemNo)),
                ]),
                _c("td", [_vm._v(_vm._s(item.itemDesc))]),
                _c(
                  "td",
                  { staticClass: "has-vertical-middle has-text-right" },
                  [_vm._v(_vm._s(item.otherPoOrderedQty))]
                ),
                _c("td", { staticClass: "has-vertical-middle" }, [
                  _vm._v(_vm._s(item.otherOrderedPo)),
                ]),
                _c(
                  "td",
                  { staticClass: "has-vertical-middle has-text-right" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "icon tooltip",
                        attrs: {
                          "data-tooltip": `Received: ${item.quantityReceived} Returned: ${item.quantityReturned}`,
                        },
                      },
                      [_vm._v(" " + _vm._s(item.quantityInStock) + " ")]
                    ),
                  ]
                ),
                _c(
                  "td",
                  { staticClass: "has-vertical-middle has-text-right" },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatNumber(
                          item.value,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]
                ),
                _c(
                  "td",
                  {
                    staticClass:
                      "has-vertical-middle has-text-centered is-content-width",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "button is-primary is-small is-inverted",
                        attrs: { disabled: _vm.isLockPurchaseOrder },
                        on: {
                          click: function ($event) {
                            return _vm.addNewItem(item, true)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "icon is-medium" }, [
                          _c("i", { staticClass: "mdi mdi-plus mdi-24px" }),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            )
          }),
          _c("template", { slot: "empty" }, [
            _c("section", { staticClass: "section" }, [
              _c(
                "div",
                { staticClass: "content has-text-grey has-text-centered" },
                [
                  _c("span", { attrs: { icon: "icon is-large" } }, [
                    _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
                  ]),
                  _c("p", [_vm._v("Nothing")]),
                ]
              ),
            ]),
          ]),
        ],
        2
      ),
      _vm.itemToAdd
        ? _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isConfirmModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.addNewItem(_vm.itemToAdd, false)
                },
                cancel: function ($event) {
                  _vm.isConfirmModalActive = false
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Item has been ordered"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(" Item "),
                  _c(
                    "span",
                    { staticClass: "has-text-primary has-text-weight-bold" },
                    [
                      _vm._v(
                        _vm._s(_vm.itemToAdd.itemNo) +
                          " - " +
                          _vm._s(_vm.itemToAdd.itemDesc)
                      ),
                    ]
                  ),
                  _vm._v(
                    " has been ordered. Are you sure you want to re-order? "
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-left" }, [
      _c("i", { staticClass: "mdi mdi-magnify mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-success" }, [
      _c("i", { staticClass: "mdi mdi-select-all mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-grey" }, [
      _c("i", { staticClass: "mdi mdi-select-off mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }